 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>
            阶段设备
            <el-tooltip
              class="item"
              effect="dark"
              content="将设备添加到对应的阶段控制中，当环境选择对应阶段控制时，会使用阶段控制中配置的设备进行环境调控。"
              placement="top"
            >
              <i
                class="el-icon-question"
                style="color: #409eff; margin-left: 5px"
              ></i>
            </el-tooltip>
          </h4>
          <el-button type="primary" class="adduser" @click="handleAdd"
            >添加</el-button
          >
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="执行控制器">
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.modelDeviceSwitchName +
                    "_" +
                    scope.row.switchAttrName
                  }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="自然控制判断" :render-header="typeRenderHeader">
              <template slot-scope="scope">
                <p v-if="scope.row.type == 0">无判断</p>
                <p v-if="scope.row.type == 1">自然控制</p>
                <p v-if="scope.row.type == 2">设备控制</p>
                
              </template>
            </el-table-column>
            <el-table-column align="center" label="执行优先级" :render-header="priorityRenderHeader">
              <template slot-scope="scope">
                <p>{{ scope.row.priority }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="执行控制器：" prop="modelDeviceSwitchId">
                  <el-select
                    v-model="ruleForm.modelDeviceSwitchId"
                    placeholder="请选择执行控制器"
                    clearable
                  >
                    <el-option
                      v-for="item in deviceArray"
                      :key="item.id"
                      :label="item.switchName + '_' + item.switchAttrName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="自然控制判断：" prop="type">
                  <el-select
                    v-model="ruleForm.type"
                    placeholder="请选择自然控制判断"
                    clearable
                  >
                    <el-option label="无判断" value="0"></el-option>
                    <el-option label="自然控制" value="1"></el-option>
                    <el-option label="设备控制" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="执行优化级：" prop="priority">
                  <el-input-number
                    v-model="ruleForm.priority"
                    placeholder="请输入执行优化级"
                    :min="0"
                    :max="99999999"
                    :precision="0"
                    :step="1"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        stageControlId: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        stageControlId: "",
        modelDeviceSwitchId: "",
        type: "",
        priority: "",
      },
      rules: {
        // 添加编辑表单规则
        modelDeviceSwitchId: [
          {
            required: true,
            message: "请选择执行控制器",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择自然控制判断",
            trigger: "change",
          },
        ],
        priority: [
          {
            required: true,
            message: "请输入执行优先级",
            trigger: "blur",
          },
        ],
      },
      stageControlId: "", // 生长模型环境参数ID
      deviceArray: [], // 设备数组
      addEditTitle: "添加阶段设备", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
    };
  },
  created() {
    this.searchForm.stageControlId = this.$route.query.stageControlId;
    this.ruleForm.stageControlId = this.$route.query.stageControlId;
    this.stageControlId = this.$route.query.stageControlId;

    // 获取执行控制器列表
    this.getGrowthModelDeviceSwitchList();

    // 查询
    this.getList();
  },
  methods: {
    // 执行优先级自定义请求头
    priorityRenderHeader(h, { column, $index }) {
      return this.renderHeader(h, { column, $index }, "将添加进来的阶段设备进行优先级划分，如划分为1,2,3个优先级，环境控制将会通过优先级依次递增的顺序进行环境调控。")
    },
    // 自然控制判断自定义请求头
    typeRenderHeader(h, { column, $index }) {
      return this.renderHeader(h, { column, $index }, "自然条件判断分为无判断、自然控制、设备控制。无判断：无需根据棚外自然环境变化对棚内环境进行调控。自然控制：当棚外环境达到对棚内环境进行调控（棚内空气温度过高，通过通风的方式降温）。ii.设备控制：当棚外环境达不到对棚内环境进行调控（通过湿帘风机或空调降温）。")
    },
    // 自定义请求头
    renderHeader(h, { column, $index }, content) {
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          {
            props: {
              effect: "dark",
              content: content,
              placement: "top",
            },
          },
          [
            h("i", {
              class: "el-icon-question",
              style: "color:#409eff;margin-left:5px;",
            }),
          ]
        ),
      ]);
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        stageControlId: this.stageControlId,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelStageDeviceList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel
            .delGrowthModelStageDevice(row.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.getList();
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑阶段设备";
      this.ruleForm.id = row.id;
      this.ruleForm.modelId = this.stageControlId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelStageDevice({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = res.data;
            this.ruleForm.type = res.data.type.toString();
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加阶段设备";
      this.ruleForm.id = "";
      this.ruleForm.modelId = this.stageControlId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelStageDevice(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 获取执行控制器列表
    getGrowthModelDeviceSwitchList() {
      this.$api.growthModel
        .getGrowthModelDeviceSwitchAll({
          paramId: this.$route.query.paramId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceArray = res.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>